<script setup lang="ts">
// Inline SVG (not a URL) — must not be used as <img src>.
// XSS-safe: svgContent is a hardcoded template literal. Never source from props
// or external data without sanitization.
const svgContent = `
<svg width="42px" height="14px" viewBox="0 0 42 14" opacity="0.3" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.07 2.14495C21.07 1.48695 21.6244 0.952148 22.2768 0.952148C22.9292 0.952148 23.4836 1.48975 23.4836 2.14495C23.4836 2.80015 22.9488 3.35175 22.2768 3.35175C21.6048 3.35175 21.07 2.81695 21.07 2.14495Z"></path>
  <path d="M17.4888 1.12014H19.5888V12.8802H17.4888V1.12014Z"></path>
  <path d="M23.338 4.48014H21.2212V12.8801H23.338V4.48014Z"></path>
  <path d="M38.556 8.39456C40.1492 7.41456 41.2328 5.95576 41.6612 4.47736H39.5444C38.9928 5.88856 37.7272 6.94976 36.3356 7.40056V1.11736H34.2188V12.8774H36.3356V9.38015C37.9512 9.78335 39.228 11.1806 39.6648 12.8774H41.7956C41.4708 11.0966 40.2528 9.43056 38.556 8.39456Z"></path>
  <path d="M27.09 5.42096C27.6444 4.68456 28.7252 4.25615 29.6016 4.25615C31.2368 4.25615 32.5892 5.45176 32.592 7.25776V12.8774H30.4752V7.72535C30.4752 6.98335 30.1448 6.12655 29.0724 6.12655C27.8124 6.12655 27.0872 7.24376 27.0872 8.55136V12.883H24.9704V4.48575H27.09V5.42096Z"></path>
  <path d="M7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0C3.13401 0 0 3.134 0 7C0 10.866 3.13401 14 7 14Z"></path>
  <path d="M6.67783 2.7998H4.51904C4.93904 4.55541 6.16544 6.0562 7.69984 6.9998C6.16264 7.9434 4.93904 9.4442 4.51904 11.1998H6.67783C7.21263 9.5758 8.69384 8.1646 10.5138 7.8762V6.12061C8.69104 5.83501 7.20983 4.42381 6.67783 2.7998Z" fill="white"></path>
</svg>
`;
</script>

<template>
  <span class="billing-link-brand-icon" aria-hidden="true" v-html="svgContent"></span>
</template>

<style lang="scss" scoped>
.billing-link-brand-icon {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  color: #000;
}
</style>
